module.exports = __webpack_public_path__ + "img/20210423_x_occ_l_logo.928b6124.png";